import { useCallback, useEffect, useMemo, useState } from 'react';
import { uniqueSortedRounds } from '../components/dashboard/UpcomingMatchTabs';

const defaultGetRound = (item) => item?.round;
const EMPTY_LIST = [];

export function useRoundFilter(items, getRound = defaultGetRound, resetKey) {
  const [view, setView] = useState('all');
  const [selectedRound, setSelectedRound] = useState('');

  const list = items || EMPTY_LIST;

  const rounds = useMemo(
    () => uniqueSortedRounds(list, getRound),
    [list, getRound]
  );

  const visibleItems = useMemo(() => {
    if (view !== 'round') return list;
    if (!selectedRound) return [];
    return list.filter((item) => getRound(item) === selectedRound);
  }, [list, view, selectedRound, getRound]);

  useEffect(() => {
    setView('all');
    setSelectedRound('');
  }, [resetKey]);

  useEffect(() => {
    if (!selectedRound) return;
    if (!rounds.includes(selectedRound)) {
      setSelectedRound('');
    }
  }, [rounds, selectedRound]);

  const handleViewChange = useCallback(
    (nextView) => {
      setView(nextView);
      if (nextView === 'round') {
        setSelectedRound((current) => current || rounds[0] || '');
      }
    },
    [rounds]
  );

  return {
    view,
    selectedRound,
    setSelectedRound,
    rounds,
    visibleItems,
    handleViewChange
  };
}
